import config from '../config';

const formatUrl = (url) => {
    if (!url) return null;

    // If it's already a full URL (including S3), return it directly
    if (url.startsWith('http')) {
        return url;
    }

    // If it's an S3 URL (contains s3.amazonaws.com), ensure proper formatting
    if (url.includes('s3.amazonaws.com')) {
        // Remove any potential double protocol or domain
        const cleanUrl = url.replace(/^.*?s3\.amazonaws\.com/, 's3.amazonaws.com');
        return `https://${cleanUrl}`;
    }

    // For local development or relative paths
    const baseUrl = config.backendUrl.replace(/\/$/, ''); // Remove trailing slash
    const imagePath = url.replace(/^\//, ''); // Remove leading slash
    return `${baseUrl}/${imagePath}`;
};

export default formatUrl;